import { useState, useEffect } from 'react';
import { Container, Card, Form, Button, Modal, Spinner, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { getPlans, subscribe } from '../../api/planApi';
import { getMyWallets } from '../../api/walletApi';
import { useAuth } from '../../context/AuthContext';

const Subscribe = () => {
  const [plans, setPlans] = useState([]);
  const [selectedPlanId, setSelectedPlanId] = useState('');
  const [mainBalance, setMainBalance] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [error, setError] = useState('');
  const { updateUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    getPlans().then((res) => setPlans(res.data.plans));
    getMyWallets().then((res) => setMainBalance(res.data.wallets.main_wallet?.balance ?? 0));
  }, []);

  const selectedPlan = plans.find((p) => p._id === selectedPlanId);
  const insufficient = selectedPlan && mainBalance !== null && mainBalance < selectedPlan.amount;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (insufficient) return;
    setError('');
    setLoading(true);
    try {
      const res = await subscribe(selectedPlanId);
      updateUser(res.data.user);
      setShowSuccess(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Subscription failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
      <Card style={{ width: '420px' }} className="p-4 shadow">
        <h4 className="text-center mb-4">Subscribe</h4>

        <div className="d-flex justify-content-between align-items-center mb-4 p-3 rounded" style={{ background: '#f8f9fa' }}>
          <span className="text-muted small">Main Wallet Balance</span>
          <span className="fw-bold">{mainBalance !== null ? mainBalance : '—'} <span className="text-muted" style={{ fontSize: '0.8rem' }}>USDT</span></span>
        </div>

        {error && <Alert variant="danger">{error}</Alert>}

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Select Plan <span className="text-danger">*</span></Form.Label>
            <Form.Select value={selectedPlanId} onChange={(e) => { setSelectedPlanId(e.target.value); setError(''); }} required>
              <option value="">-- Choose a plan --</option>
              {plans.map((plan) => (
                <option key={plan._id} value={plan._id}>
                  {plan.planName} — {plan.amount} USDT
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {insufficient && (
            <Alert variant="warning" className="py-2">
              Insufficient balance. You need <strong>{selectedPlan.amount} USDT</strong> but your Main Wallet has <strong>{mainBalance} USDT</strong>.
            </Alert>
          )}

          <Button type="submit" className="w-100 mt-2" disabled={!selectedPlanId || loading || insufficient}>
            {loading ? <Spinner animation="border" size="sm" /> : 'Subscribe Now'}
          </Button>
        </Form>
      </Card>

      <Modal show={showSuccess} centered onHide={() => navigate('/dashboard')}>
        <Modal.Header closeButton>
          <Modal.Title>Subscription Successful</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center py-4">
          <div style={{ fontSize: '3rem' }}>🎉</div>
          <h5 className="mt-2">You're all set!</h5>
          <p className="text-muted">Your plan has been activated successfully.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => navigate('/dashboard')}>Go to Dashboard</Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default Subscribe;
